import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['source', 'button']
  static values = { sourceId: String }

  select() {
    this.sourceTarget.select()
  }

  copy() {
    navigator.clipboard.writeText(this.sourceText()).then(() => {
      const original = this.buttonTarget.textContent
      this.buttonTarget.textContent = 'Copiado!'
      setTimeout(() => { this.buttonTarget.textContent = original }, 1500)
    })
  }

  sourceText() {
    const source = this.hasSourceIdValue ? document.getElementById(this.sourceIdValue) : this.sourceTarget
    return source.value === undefined ? source.textContent : source.value
  }
}
